/**
 * انتقال پیش‌فرض‌ها به فرمِ ساخت سیگنال — قرینه‌ی
 * apps/mobile/src/native/createPrefill.ts (فقط بخشِ مشترکش).
 *
 * چرا یه متغیرِ ماژول و نه پارامترِ آدرس: عنوانِ رخداد می‌تونه هر چیزی باشه و
 * چپاندنش توی query string یعنی آدرسِ زشت و یه دور encode/decode. صفحه‌ی
 * ساخت بلافاصله بعدِ همین ناوبری باز می‌شه، پس یه متغیرِ ساده کافیه.
 *
 * یه‌بار خونده می‌شه و پاک: اگه بمونه، دفعه‌ی بعد که کاربر خودش «سیگنال جدید»
 * می‌زنه، فرم با عنوانِ رخدادِ قبلی باز می‌شه.
 */
import type { SignalKind } from '@/core/domain/types';

export interface CreatePrefill {
  title?: string;
  kind?: SignalKind;
  categoryId?: number;
  /**
   * رخدادی که این سیگنال از روش ساخته می‌شه (`signals.event_id`).
   * بدونش فقط عنوان کپی می‌شد و هیچ نخی بینِ سیگنال و رخداد نمی‌موند —
   * که هم برای شمردنِ محبوبیتِ رخداد لازمه (مایگریشن 0049) هم خودش یه
   * واقعیتِ درست درباره‌ی سیگناله.
   */
  eventId?: string;
  /**
   * مکانِ رخداد، تا فرم با همون باز بشه — کاربر از روی یه رخدادِ مشخص داره
   * برنامه می‌سازه، «کجا»ش رو همون لحظه می‌دونیم.
   *
   * «کِی» عمداً این‌جا نیست: تاریخ‌های رخداد (اجراها و الگوی تکرارش) رو خودِ
   * فرم با `eventId` می‌گیره (core/lib/signalEventDate.ts) — یه نسخه از
   * حقیقت، نه یه کپی توی هر دکمه‌ی «سیگنال از روی این».
   */
  placeName?: string;
}

let prefill: CreatePrefill | null = null;
export const setCreatePrefill = (p: CreatePrefill): void => { prefill = p; };
export const takeCreatePrefill = (): CreatePrefill | null => {
  const p = prefill;
  prefill = null;
  return p;
};
